import { IconProps } from "./Icon.model";

export function GoogleGeminiIcon({
  size = 16,
  fill = "currentColor",
}: IconProps) {
  const fillColor =
    fill === "currentColor" ? "currentColor" : `var(--${fill}-a8)`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.6001 2.75C13.0143 2.75 13.3501 3.08579 13.3501 3.5C13.3501 8.05635 17.0437 11.75 21.6001 11.75C22.0143 11.75 22.3501 12.0858 22.3501 12.5C22.3501 12.9142 22.0143 13.25 21.6001 13.25C17.0437 13.25 13.3501 16.9437 13.3501 21.5C13.3501 21.9142 13.0143 22.25 12.6001 22.25C12.1859 22.25 11.8501 21.9142 11.8501 21.5C11.8501 16.9437 8.15645 13.25 3.6001 13.25C3.18588 13.25 2.8501 12.9142 2.8501 12.5C2.8501 12.0858 3.18588 11.75 3.6001 11.75C8.15645 11.75 11.8501 8.05635 11.8501 3.5C11.8501 3.08579 12.1859 2.75 12.6001 2.75Z"
        fill={fillColor}
      />
    </svg>
  );
}
